import { useState } from 'react';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { Accordion, Button, FormCheckbox, FormLabel, FormSelect, FormSelectOption } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { scopesOptions } from 'src/common/constants/admin/tagging';
import { useIsDarkMode } from 'src/common/hooks/use-is-dark-mode';
import { StyledAddTagCategory, StyledCheckboxInput, StyledDeleteIcon, StyledScopesSelector, StyledSubCategoriesContent, StyledTagCard, StyledTagCategoryHeader } from 'src/features/admin/tagging/tagging.styles';
import { TagCategoryProps } from 'src/features/admin/tagging/tagging.types';
export const TagCategoryCard = ({
  createTagCategory,
  deleteTagCategory,
  updateTagCategory,
  tagCategory,
  setAddTagCategoryModalOpen,
  setSelectedParentCategoryId
}: TagCategoryProps) => {
  const isDarkMode = useIsDarkMode();
  const [scopes, setScopes] = useState<FormSelectOption[]>(scopesOptions.filter(option => tagCategory.scopes.includes(option.value)));
  const handleScopesChange = (options: FormSelectOption[]) => {
    setScopes(options);
    updateTagCategory({
      tagCategoryId: tagCategory._id,
      body: {
        scopes: options.map(option => option.value)
      }
    });
  };
  return <StyledTagCard $isDark={false} data-testid={`tag-category-card-${tagCategory._id}`} data-sentry-element="StyledTagCard" data-sentry-component="TagCategoryCard" data-sentry-source-file="tag-category-card.tsx">
      <StyledTagCategoryHeader data-testid="tag-category-label" data-sentry-element="StyledTagCategoryHeader" data-sentry-source-file="tag-category-card.tsx">
        <h6>{tagCategory.label}</h6>
        <StyledDeleteIcon onClick={() => deleteTagCategory(tagCategory._id)} $isDark={isDarkMode} data-testid="delete-icon" data-sentry-element="StyledDeleteIcon" data-sentry-source-file="tag-category-card.tsx">
          <FontAwesomeIcon icon={faTrashCan} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="tag-category-card.tsx" />
        </StyledDeleteIcon>
      </StyledTagCategoryHeader>
      <StyledScopesSelector data-sentry-element="StyledScopesSelector" data-sentry-source-file="tag-category-card.tsx">
        <FormLabel labelPosition="left" variant="toggle" data-sentry-element="FormLabel" data-sentry-source-file="tag-category-card.tsx">
          Scopes
        </FormLabel>
        <FormSelect id="input-modal-scopes" isMulti selected={scopes} isSearchable={false} handleSelection={newValues => handleScopesChange(newValues.map(value => value))} options={scopesOptions} data-sentry-element="FormSelect" data-sentry-source-file="tag-category-card.tsx" />
      </StyledScopesSelector>
      <StyledCheckboxInput data-sentry-element="StyledCheckboxInput" data-sentry-source-file="tag-category-card.tsx">
        <FormLabel labelPosition="left" variant="toggle" data-sentry-element="FormLabel" data-sentry-source-file="tag-category-card.tsx">
          Restrict tag creation to THM admins only?
        </FormLabel>
        <FormCheckbox disabled checked={tagCategory.adminOnlyTagCreation} data-sentry-element="FormCheckbox" data-sentry-source-file="tag-category-card.tsx" />
      </StyledCheckboxInput>
      {tagCategory.subcategories.length > 0 && <Accordion title={`${tagCategory.subcategories.length} Sub${tagCategory.subcategories.length === 1 ? 'category' : 'categories'}`} data-testid="subcategories-accordion" content={<StyledSubCategoriesContent>
              {tagCategory.subcategories.map(subCat => <TagCategoryCard key={`tag-subcategory-${subCat._id}`} tagCategory={subCat} createTagCategory={createTagCategory} deleteTagCategory={deleteTagCategory} updateTagCategory={updateTagCategory} setAddTagCategoryModalOpen={setAddTagCategoryModalOpen} setSelectedParentCategoryId={setSelectedParentCategoryId} />)}
              <StyledAddTagCategory>
                <Button onClick={() => {
          setSelectedParentCategoryId(tagCategory._id);
          setAddTagCategoryModalOpen(true);
        }}>
                  Add Subcategory
                </Button>
              </StyledAddTagCategory>
            </StyledSubCategoriesContent>} />}
      {!tagCategory.parentCategory && tagCategory.subcategories.length === 0 && <StyledAddTagCategory>
          <Button onClick={() => {
        setSelectedParentCategoryId(tagCategory._id);
        setAddTagCategoryModalOpen(true);
      }}>
            Add Subcategory
          </Button>
        </StyledAddTagCategory>}
    </StyledTagCard>;
};